import { Box } from '@chakra-ui/react';
import { Canvas } from '@react-three/fiber';
import { useGame } from '../../store/game';

import GameMenu from './GameMenu';
import GameInfo from './GameInfo';
import Level from './Level'


export default function GameBoard() {

  const game = useGame()

  return <>
    <Canvas camera={{position: [0,0,10]}} orthographic>
      <Level game={game} />
    </Canvas>
    <Box id="overlay">
      <GameInfo game={game} />
      <GameMenu game={game} />
    </Box>
  </>
}


